import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import TripCreatePage from './trip-create'
import TripListPage from './trip-list'
import UpdateTripPage from './trip-update'

const tripRoutes: Route[] = [
  {
    path: Paths.TRIPS_LIST,
    element: <TripListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_CREATE_PAGE,
    element: <TripCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_UPDATE_PAGE,
    element: <UpdateTripPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripRoutes
